import React, { useEffect } from 'react';

const Loading = () => {
  useEffect(() => {
    // Заблокировать прокрутку
    const preventScroll = (e: Event) => {
      e.preventDefault();
    };

    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
    window.addEventListener('keydown', preventArrowScroll, false);

    return () => {
      // Разблокировать прокрутку
      window.removeEventListener('wheel', preventScroll);
      window.removeEventListener('touchmove', preventScroll);
      window.removeEventListener('keydown', preventArrowScroll);
    };
  }, []);

  return (
    <div style={overlayStyles}>
      <div style={modalStyles}>Processing...</div>
    </div>
  );
};

// Запретить прокрутку клавишами (стрелки, PageUp, PageDown, пробел)
const preventArrowScroll = (e: KeyboardEvent) => {
  const keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Space', ' '];
  if (keys.includes(e.key)) {
    e.preventDefault();
  }
};

const overlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'auto'
};

const modalStyles: React.CSSProperties = {
  backgroundColor: '#fff',
  color: '#7e8299',
  fontWeight: 500,
  padding: '1rem 2rem',
  borderRadius: '0.475rem',
  boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
  textAlign: 'center',
  zIndex: 10000
};

export { Loading };
